<template>
    <div :class="[appType]">
        <template v-if="!isPaymentTypeSingle()">
            <div class="summary-container">
                <div class="wplatomat-thank-you-header">
                    <h2>DZIĘKUJEMY ZA TWOJĄ WPŁATĘ!</h2>
                </div>

                <div class="wplatomat-form wplatomat-thank-you">
                    <p>Zdecydowałeś/aś się wspierać {{ systemConst.SYSTEM_ACCUSATIVE }} comiesięcznymi wpłatami.</p>
                    <p>
                        <strong>Ustaw w swoim banku polecenie stałego przelewu.</strong>
                        <br>Dzięki temu będziesz miał/a pewność, że Twoja pomoc jest skuteczna.
                    </p>
                    <h3>Dane do ustawienia polecenia stałego przelewu bankowego:</h3>

                    <div class="wplatomat-direct-info">
                        <div class="wplatomat-info-block">
                            <label>Nr konta:</label>
                            <strong>21 1750 0012 0000 0000 2060 1264</strong>
                        </div>

                        <div class="wplatomat-info-block">
                            <label>Odbiorca:</label>
                            <strong>Stowarzyszenie WIOSNA<br>ul. Wielicka 20<br> 30-552 Kraków</strong>
                        </div>

                        <div class="wplatomat-info-block">
                            <label>Tytułem:</label>
                            <strong>{{ systemConst.PAYMENT_TITLE }} comiesięcznie<span v-if="partnerName"> - {{ partnerName.toUpperCase() }}</span><span v-if="companyName">; Firma: {{ companyName }}</span></strong>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="summary-container">
                <a class="wplatomat-site-logo" :href="pageUrl" target="_blank">
                    <img :src="require(`../../assets/images/${systemConst.SUMMARY_LOGO_NAME}`)" alt="logo" title="logo"/>
                </a>
                <div class="wplatomat-form longer-h2">
                    <div class="wplatomat-block">
                        <h2>Dane do przelewu bankowego</h2>

                        <div class="wplatomat-info-block">
                            <label>Nr konta:</label>
                            <div class="block-info">21 1750 0012 0000 0000 2060 1264</div>
                        </div>

                        <div class="wplatomat-info-block">
                            <label>Odbiorca:</label>
                            <div class="block-info">Stowarzyszenie WIOSNA<br>ul. Wielicka 20<br> 30-552 Kraków</div>
                        </div>

                        <div class="wplatomat-info-block">
                            <label>Tytułem: </label>
                            <div class="block-info">{{ systemConst.PAYMENT_TITLE }}<span v-if="partnerName"> - {{ partnerName.toUpperCase() }}</span><span v-if="companyName">; Firma: {{ companyName }}</span></div>
                        </div>

                        <div class="wplatomat-info-block">
                            <label>Kwota</label>
                            <div class="block-info">{{ amount }} PLN</div>
                        </div>

                        <div class="wplatomat-info-block" v-if="null !== pdfUrl">
                            <div class="block-info">
                                <a :href="pdfUrl">
                                    <span class="blankiet-wplat"></span> &nbsp; <u>Pobierz wypełniony druk wpłaty</u>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="wplatomat-block">
                        <div class="wplatomat-separator"></div>

                        <h2 class="to-bottom">Wpłaty z zagranicy</h2>

                        <div class="wplatomat-info-block">
                            <label>Kod SWIFT:</label>
                            <div class="block-info">PPABPLPKXXX</div>
                        </div>

                        <div class="wplatomat-info-block">
                            <label>Nasz bank to:</label>
                            <div class="block-info">BNP Paribas Bank Polska S.A.<br> ul. Kasprzaka 10/16,<br> 01-211 Warszawa</div>
                        </div>

                        <div class="wplatomat-info-block margin-bottom">
                            <label>Nr konta w formacie IBAN:</label>
                            <div class="block-info">PL 21 1750 0012 0000 0000 2060 1264</div>
                        </div>
                    </div>
                </div>

                <div class="podziekowanie">
                    <h2>Dziękujemy</h2>
                    <div v-html="systemConst.THANK_YOU_TEXT_FIRST"></div>
                    <br>
                    <div v-html="systemConst.THANK_YOU_TEXT_SECOND"></div>

                    <a class="facebook-share" href="#" @click="share">
                        Udostępnij
                    </a>
                </div>
            </div>
        </template>
        <SummaryFooter />
    </div>
</template>

<script>
import paymentTypes from '../../constants/paymentTypes'
import URLSearchParams from 'url-search-params'
import axios from 'axios'
import GtmTransaction from '../../mixins/GtmTransaction'
import systemConst from '@SYSTEM_CONSTANTS'
import SummaryFooter from '../organisms/SummaryFooter'
import { PaymentEndpointResolver } from '@/helpers/paymentEndpointResolver'

export default {
    name: 'SummaryPage',
    mixins: [GtmTransaction],
    components: {
        SummaryFooter
    },
    created () {
        this.getPayment()
    },
    data () {
        return {
            appType: process.env.VUE_APP_SYSTEM,
            amount: sessionStorage.getItem('amount'),
            paymentType: sessionStorage.getItem('payment_type'),
            partnerName: null,
            companyName: null,
            pdfUrl: null,
            pageUrl: process.env.VUE_APP_PAGE_URL,
            imagesPath: process.env.VUE_APP_DEFAULT_PAYMENT_IMAGES_PATH,
            systemConst
        }
    },
    methods: {
        isPaymentTypeSingle () {
            return paymentTypes.SINGLE === this.paymentType
        },
        getPayment () {
            const urlSearch = new URLSearchParams(window.location.search)
            const token = urlSearch.get('token')

            if (token !== null) {
                let endpointResolver = new PaymentEndpointResolver()

                axios.get(endpointResolver.resolve() + '/' + token).then(({ data }) => {
                    this.pdfUrl = data.client_data.transfer_file_url
                    this.partnerName = data.client_data.partner_name
                    this.companyName = data.client_data.company_name
                })
            }
        },
        share () {
            window.open(systemConst.FB_SHARE_LINK, 'newwindow', 'width=560, height=400 ')
            return false
        }
    }
}
</script>

<style scoped>
.summary-container {
    background-color: white;
}
</style>

